"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var BrandEditor = /** @class */ (function (_super) {
    __extends(BrandEditor, _super);
    function BrandEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.key_payments = "payments";
        _this.key_contacts = "contacts";
        _this.key_pprograms = "pprograms";
        _this.key_security = "security";
        _this.key_parsing = "parsing";
        return _this;
    }
    BrandEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    brand_identity: _item.brand_identity,
                    is_manual_deposit: _item.is_manual_deposit,
                    is_manual_withdraw: _item.is_manual_withdraw,
                    is_not_verifed_players_can_withdraw: _item.is_not_verifed_players_can_withdraw,
                    bet_percent_to_withdraw: _item.bet_percent_to_withdraw,
                    bet_percent_to_points: _item.bet_percent_to_points,
                    is_players_can_use_points: _item.is_players_can_use_points,
                    withdrawal_comission_percent: _item.withdrawal_comission_percent,
                    is_promo_can_override_partner_always: _item.is_promo_can_override_partner_always,
                    promo_can_override_partner_minutes: _item.promo_can_override_partner_minutes,
                    new_usr_player_tag_id: _item.new_usr_player_tag_id,
                    new_usr_player_tag_title: _item.new_usr_player_tag_title,
                    redirect_domain: _item.redirect_domain,
                    is_use_ui_paygws: _item.is_use_ui_paygws,
                    api_secret: _item.api_secret,
                    ui_withdraw_url: _item.ui_withdraw_url,
                    tg_channel: _item.tg_channel,
                    email_security: _item.email_security,
                    email_support: _item.email_support,
                    blog_url: _item.blog_url,
                    ui_paygws_force_withdraw: _item.ui_paygws_force_withdraw,
                    cms_image_url: _item.cms_image_url,
                    is_all_country: _item.is_all_country,
                    is_players_must_verify_email: _item.is_players_must_verify_email,
                    is_auto_activate_dep_bonuses: _item.is_auto_activate_dep_bonuses,
                    is_suspicious_registration_users_from_same_ip: _item.is_suspicious_registration_users_from_same_ip,
                    suspicious_registration_users_count_by_same_ip: _item.suspicious_registration_users_count_by_same_ip,
                    suspicious_registration_interval_minute_by_same_ip: _item.suspicious_registration_interval_minute_by_same_ip,
                    //same_ip_whitelist_addresses: _item.same_ip_whitelist_addresses,
                    is_mask_error_codes: _item.is_mask_error_codes,
                    player_segmentation_behavior_type_code: _item.player_segmentation_behavior_type_code,
                    player_segmentation_behavior_type_title: _item.player_segmentation_behavior_type_title,
                    is_ip_withdrawal_check: _item.is_ip_withdrawal_check,
                    ip_withdrawal_min_ip_intersect_count: _item.ip_withdrawal_min_ip_intersect_count,
                    is_suspicious_wrong_auth_restore_users_from_same_ip: _item.is_suspicious_wrong_auth_restore_users_from_same_ip,
                    suspicious_wrong_auth_restore_users_count_by_same_ip: _item.suspicious_wrong_auth_restore_users_count_by_same_ip,
                    suspicious_wrong_auth_restore_interval_minute_by_same_ip: _item.suspicious_wrong_auth_restore_interval_minute_by_same_ip,
                    is_use_deposit_trust_zones: _item.is_use_deposit_trust_zones,
                    player_registration_by_email_behavior_type_code: _item.player_registration_by_email_behavior_type_code,
                    player_registration_by_email_behavior_type_title: _item.player_registration_by_email_behavior_type_title,
                    player_before_deposit_behavior_type_code: _item.player_before_deposit_behavior_type_code,
                    player_before_deposit_behavior_type_title: _item.player_before_deposit_behavior_type_title,
                    is_req_phone_confirmation_before_withdrawal: _item.is_req_phone_confirmation_before_withdrawal,
                    is_parsing_control: _item.is_parsing_control,
                    is_parsing_criteria_email_not_verifed: _item.is_parsing_criteria_email_not_verifed,
                    is_parsing_criteria_phone_not_verifed: _item.is_parsing_criteria_phone_not_verifed,
                    is_parsing_criteria_zero_success_dep_count: _item.is_parsing_criteria_zero_success_dep_count,
                    is_parsing_criteria_zero_created_bonuses_count: _item.is_parsing_criteria_zero_created_bonuses_count,
                    is_parsing_criteria_zero_participant_tournaments_count: _item.is_parsing_criteria_zero_participant_tournaments_count,
                    parsing_criteria_min_last_same_ip_unsuccess_dep_count: _item.parsing_criteria_min_last_same_ip_unsuccess_dep_count,
                    parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h: _item.parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h,
                    is_parsing_criteria_desktop_only: _item.is_parsing_criteria_desktop_only,
                    on_parsing_detected_action_type_code: _item.on_parsing_detected_action_type_code,
                    on_parsing_detected_action_type_title: _item.on_parsing_detected_action_type_title,
                    is_set_static_red_zone_to_players_recognized_as_bots: _item.is_set_static_red_zone_to_players_recognized_as_bots,
                    player_auth_behavior_type_code: _item.player_auth_behavior_type_code,
                    player_auth_behavior_type_title: _item.player_auth_behavior_type_title,
                    player_registration_by_sms_behavior_type_code: _item.player_registration_by_sms_behavior_type_code,
                    player_registration_by_sms_behavior_type_title: _item.player_registration_by_sms_behavior_type_title,
                    is_suspicious_success_auth_restore_users_from_same_ip: _item.is_suspicious_success_auth_restore_users_from_same_ip,
                    suspicious_success_auth_restore_users_count_by_same_ip: _item.suspicious_success_auth_restore_users_count_by_same_ip,
                    suspicious_success_auth_restore_interval_minute_by_same_ip: _item.suspicious_success_auth_restore_interval_minute_by_same_ip,
                    player_restore_password_behavior_type_code: _item.player_restore_password_behavior_type_code,
                    player_restore_password_behavior_type_title: _item.player_restore_password_behavior_type_title,
                    tabKey: this.key_main
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование бренда"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                is_locked: false,
                brand_identity: "",
                is_manual_deposit: false,
                is_manual_withdraw: false,
                withdrawal_comission_percent: 10,
                bet_percent_to_withdraw: 1,
                bet_percent_to_points: 1,
                is_players_can_use_points: true,
                is_not_verifed_players_can_withdraw: false,
                is_promo_can_override_partner_always: false,
                promo_can_override_partner_minutes: 1,
                new_usr_player_tag_id: 0,
                new_usr_player_tag_title: "",
                redirect_domain: "",
                is_use_ui_paygws: false,
                api_secret: "",
                ui_withdraw_url: "",
                tg_channel: "",
                email_security: "",
                email_support: "",
                blog_url: "",
                ui_paygws_force_withdraw: false,
                cms_image_url: "",
                is_all_country: false,
                is_players_must_verify_email: false,
                is_auto_activate_dep_bonuses: false,
                is_suspicious_registration_users_from_same_ip: false,
                suspicious_registration_users_count_by_same_ip: 5,
                suspicious_registration_interval_minute_by_same_ip: 60,
                //same_ip_whitelist_addresses: "",
                is_mask_error_codes: false,
                player_segmentation_behavior_type_code: 0,
                player_segmentation_behavior_type_title: "",
                is_ip_withdrawal_check: false,
                ip_withdrawal_min_ip_intersect_count: 0,
                is_suspicious_wrong_auth_restore_users_from_same_ip: false,
                suspicious_wrong_auth_restore_users_count_by_same_ip: 10,
                suspicious_wrong_auth_restore_interval_minute_by_same_ip: 10,
                is_use_deposit_trust_zones: false,
                player_registration_by_email_behavior_type_code: 0,
                player_registration_by_email_behavior_type_title: "",
                player_before_deposit_behavior_type_code: 0,
                player_before_deposit_behavior_type_title: "",
                is_req_phone_confirmation_before_withdrawal: false,
                is_parsing_control: false,
                is_parsing_criteria_email_not_verifed: false,
                is_parsing_criteria_phone_not_verifed: false,
                is_parsing_criteria_zero_success_dep_count: false,
                is_parsing_criteria_zero_created_bonuses_count: false,
                is_parsing_criteria_zero_participant_tournaments_count: false,
                parsing_criteria_min_last_same_ip_unsuccess_dep_count: 5,
                parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h: 10,
                is_parsing_criteria_desktop_only: false,
                on_parsing_detected_action_type_code: 0,
                on_parsing_detected_action_type_title: "",
                is_set_static_red_zone_to_players_recognized_as_bots: false,
                player_auth_behavior_type_code: 0,
                player_auth_behavior_type_title: "",
                player_registration_by_sms_behavior_type_code: 0,
                player_registration_by_sms_behavior_type_title: "",
                is_suspicious_success_auth_restore_users_from_same_ip: false,
                suspicious_success_auth_restore_users_count_by_same_ip: 5,
                suspicious_success_auth_restore_interval_minute_by_same_ip: 10,
                player_restore_password_behavior_type_code: 0,
                player_restore_password_behavior_type_title: "",
                tabKey: this.key_main
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание бренда"]);
            });
        }
        this.doReSetRules();
    };
    BrandEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            brand_identity_rules: { isError: false },
            bet_percent_to_withdraw_rules: { isError: false },
            bet_percent_to_points_rules: { isError: false },
            withdrawal_comission_percent_rules: { isError: false },
            promo_can_override_partner_minutes_rules: { isError: false },
            new_usr_player_tag_rules: { isError: false },
            redirect_domain_rules: { isError: false },
            api_secret_rules: { isError: false },
            ui_withdraw_url_rules: { isError: false },
            suspicious_registration_users_count_by_same_ip_rules: { isError: false },
            suspicious_registration_interval_minute_by_same_ip_rules: { isError: false },
            player_segmentation_behavior_type_rules: { isError: false },
            ip_withdrawal_min_ip_intersect_count_rules: { isError: false },
            suspicious_wrong_auth_restore_users_count_by_same_ip_rules: { isError: false },
            suspicious_wrong_auth_restore_interval_minute_by_same_ip_rules: { isError: false },
            player_registration_by_email_behavior_type_rules: { isError: false },
            player_before_deposit_behavior_type_rules: { isError: false },
            on_parsing_detected_action_type_rules: { isError: false },
            player_auth_behavior_type_rules: { isError: false },
            player_registration_by_sms_behavior_type_rules: { isError: false },
            suspicious_success_auth_restore_interval_minute_by_same_ip_rules: { isError: false },
            suspicious_success_auth_restore_users_count_by_same_ip_rules: { isError: false },
            player_restore_password_behavior_type_rules: { isError: false },
        });
    };
    BrandEditor.prototype.ValidateData = function () {
        if (this.state.is_use_ui_paygws) {
            if ((!this.state.api_secret) || (this.state.api_secret.length === 0)) {
                this.setState({
                    api_secret_rules: {
                        isError: true,
                        errorMessage: "Поле [api_secret] не заполнено!"
                    },
                    tabKey: this.key_main
                });
                return false;
            }
            if ((!this.state.ui_withdraw_url) || (this.state.ui_withdraw_url.length === 0)) {
                this.setState({
                    ui_withdraw_url_rules: {
                        isError: true,
                        errorMessage: "Поле [ui_withdraw_url] не заполнено!"
                    },
                    tabKey: this.key_payments
                });
                return false;
            }
        }
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: {
                    isError: true,
                    errorMessage: "Поле [название] не заполнено!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if ((!this.state.brand_identity) || (this.state.brand_identity.length === 0)) {
            this.setState({
                brand_identity_rules: {
                    isError: true,
                    errorMessage: "Поле [бренд] не выбрано!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.state.is_players_can_use_points) {
            if ((!this.state.bet_percent_to_points) || (this.state.bet_percent_to_points <= 0)) {
                this.setState({
                    bet_percent_to_points_rules: {
                        isError: true,
                        errorMessage: "Поле [процент отчисления в пойнты] не заполнено!"
                    },
                    tabKey: this.key_additional
                });
                return false;
            }
        }
        if ((!this.state.bet_percent_to_withdraw) || (this.state.bet_percent_to_withdraw <= 0)) {
            this.setState({
                bet_percent_to_withdraw_rules: {
                    isError: true,
                    errorMessage: "Поле [процент отчисления в снятие] не заполнено!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if (!this.state.is_promo_can_override_partner_always) {
            if ((!this.state.promo_can_override_partner_minutes) || (this.state.promo_can_override_partner_minutes < 1)) {
                this.setState({
                    promo_can_override_partner_minutes_rules: {
                        isError: true,
                        errorMessage: "Поле [Максимальный интервал активации партнера по промокоду(мин)] не заполнен!"
                    },
                    tabKey: this.key_pprograms
                });
                return false;
            }
        }
        if ((this.state.withdrawal_comission_percent < 0) || (this.state.withdrawal_comission_percent > 90)) {
            this.setState({
                withdrawal_comission_percent_rules: {
                    isError: true,
                    errorMessage: "Поле [процент комиссии за снятие] не заполнено!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        else {
            if ((this.state.withdrawal_comission_percent < 0) || (this.state.withdrawal_comission_percent > 90)) {
                this.setState({
                    withdrawal_comission_percent_rules: {
                        isError: true,
                        errorMessage: "Поле [процент комиссии за снятие] заполнено некорректно!"
                    },
                    tabKey: this.key_additional
                });
            }
        }
        if ((this.state.new_usr_player_tag_id <= 0) || (this.state.new_usr_player_tag_title.length === 0)) {
            this.setState({
                new_usr_player_tag_rules: {
                    isError: true,
                    errorMessage: "Поле [тэг нового пользователя] не выбрано!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if ((!this.state.redirect_domain) || (this.state.redirect_domain.length === 0)) {
            this.setState({
                redirect_domain_rules: {
                    isError: true,
                    errorMessage: "Поле [домен для редиректа] не заполнено!"
                },
                tabKey: this.key_main
            });
            return false;
        }
        if (this.state.is_suspicious_registration_users_from_same_ip) {
            if ((!this.state.suspicious_registration_users_count_by_same_ip) || (this.state.suspicious_registration_users_count_by_same_ip <= 1)) {
                this.setState({
                    suspicious_registration_users_count_by_same_ip_rules: {
                        isError: true,
                        errorMessage: "Поле [кол-во регистраций с 1 ip] не заполнено!"
                    },
                    tabKey: this.key_security
                });
                return false;
            }
            if ((!this.state.suspicious_registration_interval_minute_by_same_ip) || (this.state.suspicious_registration_interval_minute_by_same_ip <= 1)) {
                this.setState({
                    suspicious_registration_interval_minute_by_same_ip_rules: {
                        isError: true,
                        errorMessage: "Поле [таймаут регистраций с 1 ip, минут] не заполнено!"
                    },
                    tabKey: this.key_security
                });
                return false;
            }
        }
        if (this.state.is_ip_withdrawal_check) {
            if ((!this.state.ip_withdrawal_min_ip_intersect_count) || (this.state.ip_withdrawal_min_ip_intersect_count <= 1)) {
                this.setState({
                    ip_withdrawal_min_ip_intersect_count_rules: {
                        isError: true,
                        errorMessage: "Поле [кол-во пересечений по ip] не заполнено!"
                    },
                    tabKey: this.key_security
                });
                return false;
            }
        }
        if ((this.state.player_segmentation_behavior_type_code <= 0) || (this.state.player_segmentation_behavior_type_title.length === 0)) {
            this.setState({
                player_segmentation_behavior_type_rules: {
                    isError: true,
                    errorMessage: "Поле [Тип сегментации игроков] не выбрано!"
                },
                tabKey: this.key_additional
            });
            return false;
        }
        if (this.state.is_parsing_control) {
            if ((this.state.on_parsing_detected_action_type_code <= 0) || (this.state.on_parsing_detected_action_type_title.length === 0)) {
                this.setState({
                    on_parsing_detected_action_type_rules: {
                        isError: true,
                        errorMessage: "Поле [Действие при детекте] не выбрано!"
                    },
                    tabKey: this.key_parsing
                });
                return false;
            }
        }
        if ((this.state.player_registration_by_email_behavior_type_code <= 0) || (this.state.player_registration_by_email_behavior_type_title.length === 0)) {
            this.setState({
                player_registration_by_email_behavior_type_rules: {
                    isError: true,
                    errorMessage: "Поле [Капча при регистрации по email] не выбрано!"
                },
                tabKey: this.key_security
            });
            return false;
        }
        if ((this.state.player_before_deposit_behavior_type_code <= 0) || (this.state.player_before_deposit_behavior_type_title.length === 0)) {
            this.setState({
                player_before_deposit_behavior_type_rules: {
                    isError: true,
                    errorMessage: "Поле [Капча при депозите] не выбрано!"
                },
                tabKey: this.key_security
            });
            return false;
        }
        if ((this.state.player_auth_behavior_type_code <= 0) || (this.state.player_auth_behavior_type_title.length === 0)) {
            this.setState({
                player_auth_behavior_type_rules: {
                    isError: true,
                    errorMessage: "Поле [Капча при авторизации] не выбрано!"
                },
                tabKey: this.key_security
            });
            return false;
        }
        if ((this.state.player_restore_password_behavior_type_code <= 0) || (this.state.player_restore_password_behavior_type_title.length === 0)) {
            this.setState({
                player_restore_password_behavior_type_rules: {
                    isError: true,
                    errorMessage: "Поле [Капча при восстановлении пароля] не выбрано!"
                },
                tabKey: this.key_security
            });
            return false;
        }
        if ((this.state.player_registration_by_sms_behavior_type_code <= 0) || (this.state.player_registration_by_sms_behavior_type_title.length === 0)) {
            this.setState({
                player_registration_by_sms_behavior_type_rules: {
                    isError: true,
                    errorMessage: "Поле [Капча при регистрации по sms] не выбрано!"
                },
                tabKey: this.key_security
            });
            return false;
        }
        if (this.state.is_suspicious_wrong_auth_restore_users_from_same_ip) {
            if (this.state.suspicious_wrong_auth_restore_users_count_by_same_ip <= 0) {
                this.setState({
                    suspicious_wrong_auth_restore_users_count_by_same_ip_rules: {
                        isError: true,
                        errorMessage: "Поле [кол-во игроков с одного ip] заполнено некорректно!"
                    },
                    tabKey: this.key_security
                });
            }
            if (this.state.suspicious_wrong_auth_restore_interval_minute_by_same_ip <= 0) {
                this.setState({
                    suspicious_wrong_auth_restore_interval_minute_by_same_ip_rules: {
                        isError: true,
                        errorMessage: "Поле [интервал авторизаций/восстановления пароля с одного ip] заполнено некорректно!"
                    },
                    tabKey: this.key_security
                });
            }
        }
        if (this.state.is_suspicious_success_auth_restore_users_from_same_ip) {
            if (this.state.suspicious_success_auth_restore_users_count_by_same_ip <= 0) {
                this.setState({
                    suspicious_success_auth_restore_users_count_by_same_ip_rules: {
                        isError: true,
                        errorMessage: "Поле [кол-во игроков с одного ip] заполнено некорректно!"
                    },
                    tabKey: this.key_security
                });
            }
            if (this.state.suspicious_success_auth_restore_interval_minute_by_same_ip <= 0) {
                this.setState({
                    suspicious_success_auth_restore_interval_minute_by_same_ip_rules: {
                        isError: true,
                        errorMessage: "Поле [интервал авторизаций/восстановления пароля с одного ip] заполнено некорректно!"
                    },
                    tabKey: this.key_security
                });
            }
        }
        return true;
    };
    BrandEditor.prototype.OnUpdateDataClick = function () {
        if (this.ValidateData()) {
            this.props.data.EditBrand({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                is_locked: this.state.is_locked,
                is_manual_deposit: this.state.is_manual_deposit,
                is_manual_withdraw: this.state.is_manual_withdraw,
                bet_percent_to_points: this.state.bet_percent_to_points,
                bet_percent_to_withdraw: this.state.bet_percent_to_withdraw,
                is_players_can_use_points: this.state.is_players_can_use_points,
                withdrawal_comission_percent: this.state.withdrawal_comission_percent,
                is_not_verifed_players_can_withdraw: this.state.is_not_verifed_players_can_withdraw,
                promo_can_override_partner_minutes: this.state.promo_can_override_partner_minutes,
                is_promo_can_override_partner_always: this.state.is_promo_can_override_partner_always,
                new_usr_player_tag_id: this.state.new_usr_player_tag_id,
                redirect_domain: this.state.redirect_domain,
                is_use_ui_paygws: this.state.is_use_ui_paygws,
                api_secret: this.state.api_secret,
                ui_withdraw_url: this.state.ui_withdraw_url,
                tg_channel: this.state.tg_channel,
                email_security: this.state.email_security,
                email_support: this.state.email_support,
                blog_url: this.state.blog_url,
                ui_paygws_force_withdraw: this.state.ui_paygws_force_withdraw,
                cms_image_url: this.state.cms_image_url,
                is_all_country: this.state.is_all_country,
                is_players_must_verify_email: this.state.is_players_must_verify_email,
                is_auto_activate_dep_bonuses: this.state.is_auto_activate_dep_bonuses,
                is_suspicious_registration_users_from_same_ip: this.state.is_suspicious_registration_users_from_same_ip,
                suspicious_registration_users_count_by_same_ip: this.state.suspicious_registration_users_count_by_same_ip,
                suspicious_registration_interval_minute_by_same_ip: this.state.suspicious_registration_interval_minute_by_same_ip,
                //same_ip_whitelist_addresses: this.state.same_ip_whitelist_addresses,
                is_mask_error_codes: this.state.is_mask_error_codes,
                player_segmentation_behavior_type_code: this.state.player_segmentation_behavior_type_code,
                is_ip_withdrawal_check: this.state.is_ip_withdrawal_check,
                ip_withdrawal_min_ip_intersect_count: this.state.ip_withdrawal_min_ip_intersect_count,
                is_suspicious_wrong_auth_restore_users_from_same_ip: this.state.is_suspicious_wrong_auth_restore_users_from_same_ip,
                suspicious_wrong_auth_restore_users_count_by_same_ip: this.state.suspicious_wrong_auth_restore_users_count_by_same_ip,
                suspicious_wrong_auth_restore_interval_minute_by_same_ip: this.state.suspicious_wrong_auth_restore_interval_minute_by_same_ip,
                is_use_deposit_trust_zones: this.state.is_use_deposit_trust_zones,
                player_registration_by_email_behavior_type_code: this.state.player_registration_by_email_behavior_type_code,
                player_before_deposit_behavior_type_code: this.state.player_before_deposit_behavior_type_code,
                is_req_phone_confirmation_before_withdrawal: this.state.is_req_phone_confirmation_before_withdrawal,
                is_parsing_control: this.state.is_parsing_control,
                is_parsing_criteria_email_not_verifed: this.state.is_parsing_criteria_email_not_verifed,
                is_parsing_criteria_phone_not_verifed: this.state.is_parsing_criteria_phone_not_verifed,
                is_parsing_criteria_zero_success_dep_count: this.state.is_parsing_criteria_zero_success_dep_count,
                is_parsing_criteria_zero_created_bonuses_count: this.state.is_parsing_criteria_zero_created_bonuses_count,
                is_parsing_criteria_zero_participant_tournaments_count: this.state.is_parsing_criteria_zero_participant_tournaments_count,
                parsing_criteria_min_last_same_ip_unsuccess_dep_count: this.state.parsing_criteria_min_last_same_ip_unsuccess_dep_count,
                parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h: this.state.parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h,
                is_parsing_criteria_desktop_only: this.state.is_parsing_criteria_desktop_only,
                on_parsing_detected_action_type_code: this.state.on_parsing_detected_action_type_code,
                is_set_static_red_zone_to_players_recognized_as_bots: this.state.is_set_static_red_zone_to_players_recognized_as_bots,
                player_auth_behavior_type_code: this.state.player_auth_behavior_type_code,
                player_registration_by_sms_behavior_type_code: this.state.player_registration_by_sms_behavior_type_code,
                is_suspicious_success_auth_restore_users_from_same_ip: this.state.is_suspicious_success_auth_restore_users_from_same_ip,
                suspicious_success_auth_restore_users_count_by_same_ip: this.state.suspicious_success_auth_restore_users_count_by_same_ip,
                suspicious_success_auth_restore_interval_minute_by_same_ip: this.state.suspicious_success_auth_restore_interval_minute_by_same_ip,
                player_restore_password_behavior_type_code: this.state.player_restore_password_behavior_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бренд изменен!");
            });
        }
    };
    BrandEditor.prototype.OnNewDataClick = function () {
        if (this.ValidateData()) {
            this.props.data.AddBrand({
                description: this.state.description,
                title: this.state.title,
                is_locked: this.state.is_locked,
                brand_identity: this.state.brand_identity,
                is_manual_deposit: this.state.is_manual_deposit,
                is_manual_withdraw: this.state.is_manual_withdraw,
                bet_percent_to_points: this.state.bet_percent_to_points,
                bet_percent_to_withdraw: this.state.bet_percent_to_withdraw,
                is_players_can_use_points: this.state.is_players_can_use_points,
                withdrawal_comission_percent: this.state.withdrawal_comission_percent,
                is_not_verifed_players_can_withdraw: this.state.is_not_verifed_players_can_withdraw,
                promo_can_override_partner_minutes: this.state.promo_can_override_partner_minutes,
                is_promo_can_override_partner_always: this.state.is_promo_can_override_partner_always,
                new_usr_player_tag_id: this.state.new_usr_player_tag_id,
                redirect_domain: this.state.redirect_domain,
                is_use_ui_paygws: this.state.is_use_ui_paygws,
                api_secret: this.state.api_secret,
                ui_withdraw_url: this.state.ui_withdraw_url,
                tg_channel: this.state.tg_channel,
                email_security: this.state.email_security,
                email_support: this.state.email_support,
                blog_url: this.state.blog_url,
                ui_paygws_force_withdraw: this.state.ui_paygws_force_withdraw,
                cms_image_url: this.state.cms_image_url,
                is_all_country: this.state.is_all_country,
                is_players_must_verify_email: this.state.is_players_must_verify_email,
                is_auto_activate_dep_bonuses: this.state.is_auto_activate_dep_bonuses,
                is_suspicious_registration_users_from_same_ip: this.state.is_suspicious_registration_users_from_same_ip,
                suspicious_registration_users_count_by_same_ip: this.state.suspicious_registration_users_count_by_same_ip,
                suspicious_registration_interval_minute_by_same_ip: this.state.suspicious_registration_interval_minute_by_same_ip,
                //same_ip_whitelist_addresses: this.state.same_ip_whitelist_addresses,
                is_mask_error_codes: this.state.is_mask_error_codes,
                player_segmentation_behavior_type_code: this.state.player_segmentation_behavior_type_code,
                is_ip_withdrawal_check: this.state.is_ip_withdrawal_check,
                ip_withdrawal_min_ip_intersect_count: this.state.ip_withdrawal_min_ip_intersect_count,
                is_suspicious_wrong_auth_restore_users_from_same_ip: this.state.is_suspicious_wrong_auth_restore_users_from_same_ip,
                suspicious_wrong_auth_restore_users_count_by_same_ip: this.state.suspicious_wrong_auth_restore_users_count_by_same_ip,
                suspicious_wrong_auth_restore_interval_minute_by_same_ip: this.state.suspicious_wrong_auth_restore_interval_minute_by_same_ip,
                is_use_deposit_trust_zones: this.state.is_use_deposit_trust_zones,
                player_registration_by_email_behavior_type_code: this.state.player_registration_by_email_behavior_type_code,
                player_before_deposit_behavior_type_code: this.state.player_before_deposit_behavior_type_code,
                is_req_phone_confirmation_before_withdrawal: this.state.is_req_phone_confirmation_before_withdrawal,
                is_parsing_control: this.state.is_parsing_control,
                is_parsing_criteria_email_not_verifed: this.state.is_parsing_criteria_email_not_verifed,
                is_parsing_criteria_phone_not_verifed: this.state.is_parsing_criteria_phone_not_verifed,
                is_parsing_criteria_zero_success_dep_count: this.state.is_parsing_criteria_zero_success_dep_count,
                is_parsing_criteria_zero_created_bonuses_count: this.state.is_parsing_criteria_zero_created_bonuses_count,
                is_parsing_criteria_zero_participant_tournaments_count: this.state.is_parsing_criteria_zero_participant_tournaments_count,
                parsing_criteria_min_last_same_ip_unsuccess_dep_count: this.state.parsing_criteria_min_last_same_ip_unsuccess_dep_count,
                parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h: this.state.parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h,
                is_parsing_criteria_desktop_only: this.state.is_parsing_criteria_desktop_only,
                on_parsing_detected_action_type_code: this.state.on_parsing_detected_action_type_code,
                is_set_static_red_zone_to_players_recognized_as_bots: this.state.is_set_static_red_zone_to_players_recognized_as_bots,
                player_auth_behavior_type_code: this.state.player_auth_behavior_type_code,
                player_registration_by_sms_behavior_type_code: this.state.player_registration_by_sms_behavior_type_code,
                is_suspicious_success_auth_restore_users_from_same_ip: this.state.is_suspicious_success_auth_restore_users_from_same_ip,
                suspicious_success_auth_restore_users_count_by_same_ip: this.state.suspicious_success_auth_restore_users_count_by_same_ip,
                suspicious_success_auth_restore_interval_minute_by_same_ip: this.state.suspicious_success_auth_restore_interval_minute_by_same_ip,
                player_restore_password_behavior_type_code: this.state.player_restore_password_behavior_type_code
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бренд создан!");
            });
        }
    };
    BrandEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый Бренд";
        }
        else {
            return "Изменить Бренд";
        }
    };
    BrandEditor.prototype.doGenerateApiPayKey = function () {
        var _this = this;
        this.props.data.GenerateBrandApiSecret(function (api_key) {
            _this.setState({ api_secret: api_key }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Api pay ключ сгенерирован!");
            });
        });
    };
    //
    BrandEditor.prototype.getMainContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, rules: this.state.title_rules, required: true }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Идентификатор бренда:", placeholder: "Введите идентификатор бренда" }, value: this.state.brand_identity, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_identity: newVal,
                        brand_identity_rules: { isError: false }
                    });
                }, rules: this.state.brand_identity_rules, required: this.props.record == null, disabled: this.props.record != null }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Api secret ключ:", placeholder: "Сгенерируйте Api secret ключ", buttonHint: "Сгенерировать Api secret ключ" }, readonly: true, onButtonClick: this.doGenerateApiPayKey.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        api_secret: newVal,
                        api_secret_rules: { isError: false }
                    });
                }, value: this.state.api_secret, buttonIcon: "key", rules: this.state.api_secret_rules, required: true, disabled: false }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Домен для редиректа:", placeholder: "Введите домен для редиректа" }, value: this.state.redirect_domain, onValueChanged: function (newVal) {
                    _this.setState({
                        redirect_domain: newVal,
                        redirect_domain_rules: { isError: false }
                    });
                }, rules: this.state.redirect_domain_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешить ручное пополнение средств игроков", value: this.state.is_manual_deposit, onChecked: function (checked) {
                    _this.setState({
                        is_manual_deposit: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешить ручное снятие средств игроков", value: this.state.is_manual_withdraw, onChecked: function (checked) {
                    _this.setState({
                        is_manual_withdraw: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бренд заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ cms_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    BrandEditor.prototype.getAdditionalContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Разрешить заявки на снятие для неверифицированных игроков", value: this.state.is_not_verifed_players_can_withdraw, onChecked: function (checked) {
                    _this.setState({
                        is_not_verifed_players_can_withdraw: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Процент от ставки в снятия:", placeholder: "Введите процент отчисления в снятия (от ставки)" }, values: { max: 100, min: 0.001, value: this.state.bet_percent_to_withdraw }, onValueChanged: function (newVal) {
                    _this.setState({
                        bet_percent_to_withdraw: newVal,
                        bet_percent_to_withdraw_rules: { isError: false }
                    });
                }, required: true, precision: 3, rules: this.state.bet_percent_to_withdraw_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать пойнты", value: this.state.is_players_can_use_points, onChecked: function (checked) {
                    _this.setState({
                        is_players_can_use_points: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Процент от ставки в пойнты:",
                    placeholder: "Введите процент отчисления в пойнты (от ставки)"
                }, values: {
                    max: 100,
                    min: 0.001,
                    value: this.state.bet_percent_to_points
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        bet_percent_to_points: newVal,
                        bet_percent_to_points_rules: { isError: false }
                    });
                }, required: true, precision: 3, rules: this.state.bet_percent_to_points_rules, disabled: !this.state.is_players_can_use_points }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "% комиссии за снятие:",
                    placeholder: "Введите процент комиссии за снятие средств"
                }, values: {
                    max: 90,
                    min: 0.0,
                    value: this.state.withdrawal_comission_percent
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        withdrawal_comission_percent: newVal,
                        withdrawal_comission_percent_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.withdrawal_comission_percent_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Метка новых игроков :", placeholder: "Выберите метку для новых игроков" }, value: { key: this.state.new_usr_player_tag_id, value: this.state.new_usr_player_tag_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        new_usr_player_tag_id: newVal.key,
                        new_usr_player_tag_title: newVal.value
                    });
                }, items: this.props.app_usr_player_tags, required: true, rules: this.state.new_usr_player_tag_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать подтверждение почты игроком после регистрации", value: this.state.is_players_must_verify_email, onChecked: function (checked) {
                    _this.setState({
                        is_players_must_verify_email: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Активировать депозитный бонус в момент создания", value: this.state.is_auto_activate_dep_bonuses, onChecked: function (checked) {
                    _this.setState({
                        is_auto_activate_dep_bonuses: checked
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип сегментации :", placeholder: "Выберите тип сегментации ртп игроков" }, value: { key: this.state.player_segmentation_behavior_type_code, value: this.state.player_segmentation_behavior_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_segmentation_behavior_type_code: newVal.key,
                        player_segmentation_behavior_type_title: newVal.value,
                        player_segmentation_behavior_type_rules: { isError: false }
                    });
                }, items: this.props.player_segmentation_avail, required: true, rules: this.state.player_segmentation_behavior_type_rules }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.getPayContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать платежный шлюз на стороне UI", value: this.state.is_use_ui_paygws, onChecked: function (checked) {
                    _this.setState({
                        is_use_ui_paygws: checked
                    });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "UI withdraw url:", placeholder: "Введите UI withdraw url" }, value: this.state.ui_withdraw_url, onValueChanged: function (newVal) {
                    _this.setState({
                        ui_withdraw_url: newVal
                    });
                }, disabled: !this.state.is_use_ui_paygws }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Принудительное снятие без подтверждения", value: this.state.ui_paygws_force_withdraw, onChecked: function (checked) {
                    _this.setState({
                        ui_paygws_force_withdraw: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Требовать подтверждения номера телефона для выплаты", value: this.state.is_req_phone_confirmation_before_withdrawal, onChecked: function (checked) {
                    _this.setState({
                        is_req_phone_confirmation_before_withdrawal: checked
                    });
                } }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.getContactsContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Телеграм канал:", placeholder: "Введите телеграм канал" }, value: this.state.tg_channel, onValueChanged: function (newVal) { _this.setState({ tg_channel: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Email техподдержки:", placeholder: "Введите Email техподдержки" }, value: this.state.email_support, onValueChanged: function (newVal) { _this.setState({ email_support: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Email безопасности:", placeholder: "Введите Email безопасности" }, value: this.state.email_security, onValueChanged: function (newVal) { _this.setState({ email_security: newVal }); } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Url блога:", placeholder: "Введите url блога" }, value: this.state.blog_url, onValueChanged: function (newVal) { _this.setState({ blog_url: newVal }); } }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.getPProgramsContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        cms_image_url: newVal
                    });
                }, value: this.state.cms_image_url, buttonIcon: "search" }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Доступно для всех стран", value: this.state.is_all_country, onChecked: function (checked) {
                    _this.setState({
                        is_all_country: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Данные о партнере из промокода перезаписываются всегда", value: this.state.is_promo_can_override_partner_always, onChecked: function (checked) {
                    _this.setState({
                        is_promo_can_override_partner_always: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Макс промо партнера, мин:",
                    placeholder: "Введите максимальный интервал перезаписи партнера по промокоду, мин"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.promo_can_override_partner_minutes
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        promo_can_override_partner_minutes: newVal,
                        promo_can_override_partner_minutes_rules: { isError: false }
                    });
                }, required: !this.state.is_promo_can_override_partner_always, disabled: this.state.is_promo_can_override_partner_always, rules: this.state.promo_can_override_partner_minutes_rules }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.getSecurityContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Маскировать коды ошибок", value: this.state.is_mask_error_codes, onChecked: function (checked) {
                    _this.setState({
                        is_mask_error_codes: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Проверять выплаты по ip", value: this.state.is_ip_withdrawal_check, onChecked: function (checked) {
                    _this.setState({
                        is_ip_withdrawal_check: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Мин пресечений по ip:",
                    placeholder: "Минимальное кол-во пересечений по ip, для активации проверки"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.ip_withdrawal_min_ip_intersect_count
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        ip_withdrawal_min_ip_intersect_count: newVal,
                        ip_withdrawal_min_ip_intersect_count_rules: { isError: false }
                    });
                }, required: this.state.is_ip_withdrawal_check, disabled: !this.state.is_ip_withdrawal_check, rules: this.state.ip_withdrawal_min_ip_intersect_count_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать доверенные зоны для списка способов депозитов", value: this.state.is_use_deposit_trust_zones, onChecked: function (checked) {
                    _this.setState({
                        is_use_deposit_trust_zones: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Считать подозрительными регистрации с 1 ip адреса по критериям:", value: this.state.is_suspicious_registration_users_from_same_ip, onChecked: function (checked) {
                    _this.setState({
                        is_suspicious_registration_users_from_same_ip: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Мин рег с ip:",
                    placeholder: "Введите минимальное количество регистраций с одного ip"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.suspicious_registration_users_count_by_same_ip
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        suspicious_registration_users_count_by_same_ip: newVal,
                        suspicious_registration_users_count_by_same_ip_rules: { isError: false }
                    });
                }, required: this.state.is_suspicious_registration_users_from_same_ip, disabled: !this.state.is_suspicious_registration_users_from_same_ip, rules: this.state.suspicious_registration_users_count_by_same_ip_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Интервал, минут:",
                    placeholder: "Введите интервал для регистраций, минут"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.suspicious_registration_interval_minute_by_same_ip
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        suspicious_registration_interval_minute_by_same_ip: newVal,
                        suspicious_registration_interval_minute_by_same_ip_rules: { isError: false }
                    });
                }, required: this.state.is_suspicious_registration_users_from_same_ip, disabled: !this.state.is_suspicious_registration_users_from_same_ip, rules: this.state.suspicious_registration_interval_minute_by_same_ip_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Капча, при реге по email :", placeholder: "Выберите тип поведения капчи при регистрации по email" }, value: { key: this.state.player_registration_by_email_behavior_type_code, value: this.state.player_registration_by_email_behavior_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_registration_by_email_behavior_type_code: newVal.key,
                        player_registration_by_email_behavior_type_title: newVal.value,
                        player_registration_by_email_behavior_type_rules: { isError: false }
                    });
                }, items: this.props.player_registration_avail, required: true, rules: this.state.player_registration_by_email_behavior_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Капча, при реге по sms :", placeholder: "Выберите тип поведения капчи при регистрации по sms" }, value: { key: this.state.player_registration_by_sms_behavior_type_code, value: this.state.player_registration_by_sms_behavior_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_registration_by_sms_behavior_type_code: newVal.key,
                        player_registration_by_sms_behavior_type_title: newVal.value,
                        player_registration_by_sms_behavior_type_rules: { isError: false }
                    });
                }, items: this.props.player_registration_avail, required: true, rules: this.state.player_registration_by_sms_behavior_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Капча, при депозите :", placeholder: "Выберите тип поведения капчи при депозите" }, value: { key: this.state.player_before_deposit_behavior_type_code, value: this.state.player_before_deposit_behavior_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_before_deposit_behavior_type_code: newVal.key,
                        player_before_deposit_behavior_type_title: newVal.value,
                        player_before_deposit_behavior_type_rules: { isError: false }
                    });
                }, items: this.props.player_registration_avail, required: true, rules: this.state.player_before_deposit_behavior_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Считать подозрительными ошибки авторизации/восстановления пароля с ip адреса по критериям", value: this.state.is_suspicious_wrong_auth_restore_users_from_same_ip, onChecked: function (checked) {
                    _this.setState({
                        is_suspicious_wrong_auth_restore_users_from_same_ip: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Мин игроков с одного ip:",
                    placeholder: "Минимальное кол-во игроков с ошибочной авторизацией/восстановлением пароля с 1 ip"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.suspicious_wrong_auth_restore_users_count_by_same_ip
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        suspicious_wrong_auth_restore_users_count_by_same_ip: newVal,
                        suspicious_wrong_auth_restore_users_count_by_same_ip_rules: { isError: false }
                    });
                }, required: this.state.is_suspicious_wrong_auth_restore_users_from_same_ip, disabled: !this.state.is_suspicious_wrong_auth_restore_users_from_same_ip, rules: this.state.suspicious_wrong_auth_restore_users_count_by_same_ip_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Интервал, минут:",
                    placeholder: "Интервал, минут, в течении которого было набрано вышеуказанное кол-во ошибочных авторизаций/восстановлений пароля"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.suspicious_wrong_auth_restore_interval_minute_by_same_ip
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        suspicious_wrong_auth_restore_interval_minute_by_same_ip: newVal,
                        suspicious_wrong_auth_restore_interval_minute_by_same_ip_rules: { isError: false }
                    });
                }, required: this.state.is_suspicious_wrong_auth_restore_users_from_same_ip, disabled: !this.state.is_suspicious_wrong_auth_restore_users_from_same_ip, rules: this.state.suspicious_wrong_auth_restore_interval_minute_by_same_ip_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Считать подозрительными успешные авторизации/восстановления пароля с ip адреса по критериям", value: this.state.is_suspicious_success_auth_restore_users_from_same_ip, onChecked: function (checked) {
                    _this.setState({
                        is_suspicious_success_auth_restore_users_from_same_ip: checked
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Мин игроков с одного ip:",
                    placeholder: "Минимальное кол-во игроков с успешной авторизацией/восстановлением пароля с 1 ip"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.suspicious_success_auth_restore_users_count_by_same_ip
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        suspicious_success_auth_restore_users_count_by_same_ip: newVal,
                        suspicious_success_auth_restore_users_count_by_same_ip_rules: { isError: false }
                    });
                }, required: this.state.is_suspicious_success_auth_restore_users_from_same_ip, disabled: !this.state.is_suspicious_success_auth_restore_users_from_same_ip, rules: this.state.suspicious_success_auth_restore_users_count_by_same_ip_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Интервал, минут:",
                    placeholder: "Интервал, минут, в течении которого было набрано вышеуказанное кол-во успешных авторизаций/восстановлений пароля"
                }, values: {
                    max: 999999999,
                    min: 1,
                    value: this.state.suspicious_success_auth_restore_interval_minute_by_same_ip
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        suspicious_success_auth_restore_interval_minute_by_same_ip: newVal,
                        suspicious_success_auth_restore_interval_minute_by_same_ip_rules: { isError: false }
                    });
                }, required: this.state.is_suspicious_success_auth_restore_users_from_same_ip, disabled: !this.state.is_suspicious_success_auth_restore_users_from_same_ip, rules: this.state.suspicious_success_auth_restore_interval_minute_by_same_ip_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Капча, при авторизации :", placeholder: "Выберите тип поведения капчи при авторизации" }, value: { key: this.state.player_auth_behavior_type_code, value: this.state.player_auth_behavior_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_auth_behavior_type_code: newVal.key,
                        player_auth_behavior_type_title: newVal.value,
                        player_auth_behavior_type_rules: { isError: false }
                    });
                }, items: this.props.player_registration_avail, required: true, rules: this.state.player_auth_behavior_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Капча, при восстановлении :", placeholder: "Выберите тип поведения капчи при восстановлении пароля" }, value: { key: this.state.player_restore_password_behavior_type_code, value: this.state.player_restore_password_behavior_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        player_restore_password_behavior_type_code: newVal.key,
                        player_restore_password_behavior_type_title: newVal.value,
                        player_restore_password_behavior_type_rules: { isError: false }
                    });
                }, items: this.props.player_registration_avail, required: true, rules: this.state.player_restore_password_behavior_type_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устанавливать красную зону доверия для игроков, зарегестрированных через средства автоматизации", value: this.state.is_set_static_red_zone_to_players_recognized_as_bots, onChecked: function (checked) {
                    _this.setState({
                        is_set_static_red_zone_to_players_recognized_as_bots: checked
                    });
                } }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.getParsingContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Включить контроль парсинга по критериям", value: this.state.is_parsing_control, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_control: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Почта не подтверждена", value: this.state.is_parsing_criteria_email_not_verifed, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_criteria_email_not_verifed: checked
                    });
                }, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Телефон не подтвержден", value: this.state.is_parsing_criteria_phone_not_verifed, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_criteria_phone_not_verifed: checked
                    });
                }, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Нулевое кол-во успешных депов", value: this.state.is_parsing_criteria_zero_success_dep_count, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_criteria_zero_success_dep_count: checked
                    });
                }, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Нулевое кол-во бонусов", value: this.state.is_parsing_criteria_zero_created_bonuses_count, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_criteria_zero_created_bonuses_count: checked
                    });
                }, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Нулевое код-во турниров", value: this.state.is_parsing_criteria_zero_participant_tournaments_count, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_criteria_zero_participant_tournaments_count: checked
                    });
                }, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Кол-во новых депов с 1 ip:",
                    placeholder: "Введите количество неуспешных депов с 1 ip за интервал"
                }, values: {
                    max: 90,
                    min: 0.0,
                    value: this.state.parsing_criteria_min_last_same_ip_unsuccess_dep_count
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        parsing_criteria_min_last_same_ip_unsuccess_dep_count: newVal
                    });
                }, required: true, precision: 0, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowNumericEditor_1.default, { texts: {
                    caption: "Период депов, час:",
                    placeholder: "Введите период, за который считается кол-во депов"
                }, values: {
                    max: 90,
                    min: 0.0,
                    value: this.state.parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        parsing_criteria_min_last_same_ip_unsuccess_dep_interval_h: newVal
                    });
                }, required: true, precision: 0, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Только для десктопа", value: this.state.is_parsing_criteria_desktop_only, onChecked: function (checked) {
                    _this.setState({
                        is_parsing_criteria_desktop_only: checked
                    });
                }, disabled: !this.state.is_parsing_control }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Действие при детекте:", placeholder: "Выберите тип действия при детекте" }, value: { key: this.state.on_parsing_detected_action_type_code, value: this.state.on_parsing_detected_action_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        on_parsing_detected_action_type_code: newVal.key,
                        on_parsing_detected_action_type_title: newVal.value,
                        on_parsing_detected_action_type_rules: { isError: false }
                    });
                }, items: this.props.player_on_parse_actions_avail, required: true, rules: this.state.on_parsing_detected_action_type_rules, disabled: !this.state.is_parsing_control }),
            this.getDownButtons()));
    };
    BrandEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalContent();
        }
        if (this.state.tabKey === this.key_payments) {
            return this.getPayContent();
        }
        if (this.state.tabKey == this.key_contacts) {
            return this.getContactsContent();
        }
        if (this.state.tabKey == this.key_pprograms) {
            return this.getPProgramsContent();
        }
        if (this.state.tabKey == this.key_security) {
            return this.getSecurityContent();
        }
        if (this.state.tabKey == this.key_parsing) {
            return this.getParsingContent();
        }
        throw "invalid tabkey -> " + this.state.tabKey;
    };
    BrandEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BrandEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 1170, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" },
                { key: this.key_payments, tab: "Платежи" },
                { key: this.key_contacts, tab: "Контакты" },
                { key: this.key_pprograms, tab: "П.Программы" },
                { key: this.key_security, tab: "Безопасность" },
                { key: this.key_parsing, tab: "Парсинг" },
            ], onTabChange: function (key) { _this.setState({ tabKey: key }); } }, this.getContent()));
    };
    return BrandEditor;
}(React.Component));
exports.default = BrandEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/BrandEditor.tsx
// module id = 1756
// module chunks = 0